import React, { useState, useRef, useContext } from "react";
import { usePdf } from "@mikecousins/react-pdf";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";

export default function LibraryPdfView(props) {
  const [page, setPage] = useState(1);
  const canvasRef = useRef(null);
  const cx = useContext(Context);

  const { pdfDocument } = usePdf({
    file: props.base64,
    page,
    canvasRef,
    onDocumentLoadFail: () => {
      cx.toast("Не удалось загрузить PDF документ", "warning");
    },
    onPageLoadFail: () => {
      cx.toast("Не удалось загрузить страницу PDF документа", "warning");
    },
  });

  const renderPaginationButtons = (pdfDocument) => {
    if (pdfDocument && pdfDocument.numPages) {
      return (
        <>
          <span className="text-muted mr-3">
            стр.
            <input
              className="w-auto form-control d-inline-block mx-2"
              size={2}
              value={page}
              onChange={(e) => {
                let page = parseInt(e.target.value);
                if (page && page > 0 && page <= pdfDocument.numPages) {
                  setPage(page);
                }
              }}
            />
            /{pdfDocument.numPages}
          </span>
          <button
            className="btn btn-light btn-icon ml-3 mr-2"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            title="Предыдущая страница"
          >
            <i className="fa fa-angle-left"></i>
          </button>
          <button
            className="btn btn-light btn-icon mr-2"
            disabled={page === pdfDocument.numPages}
            onClick={() => setPage(page + 1)}
            title="Следующая страница"
          >
            <i className="fa fa-angle-right"></i>
          </button>
        </>
      );
    }
  };

  const renderButtons = () => {
    return (
      <>
        <button
          className="btn btn-light btn-icon mr-2"
          onClick={props.downloadClick}
          title="Скачать документ"
        >
          <i className="fa fa-download"></i>
        </button>
      </>
    );
  };

  return (
    <div>
      <Blocker on={!pdfDocument}>
        <div className="mb-3 px-5 py-4 border-bottom text-right">
          {renderPaginationButtons(pdfDocument)}
          {renderButtons()}
        </div>
        <canvas className="pdfCanvas" ref={canvasRef} />
      </Blocker>
    </div>
  );
}
